import React, { Component, Fragment } from "react";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import renderHTML from 'react-render-html';

class PackDescription extends Component {
  render() {
    const { images, title, description } = this.props;
    return(
      <Fragment>
        <Grid item xs={12} md={4}>
          <img src="/assets/images/ks40.jpg" style={{width: '100%'}}/>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography variant="h5">
            {title}
          </Typography>
          <Typography variant="body1">
            {renderHTML(description)}
          </Typography>
        </Grid>
      </Fragment>
    )
  }
}

export default PackDescription;